// src/pages/AQSense.jsx
import React from "react";
import { Helmet } from "react-helmet-async";

const FORM_LINK =
  "https://docs.google.com/forms/d/e/1FAIpQLScX8uQdL0EhDjfwl9WbGK7Plr52nNAqOYcSG-BnslHs6cZqug/viewform?usp=header";

export default function AQSense() {
  return (
    <section className="max-w-6xl mx-auto px-4 py-20">
      {/* ============================
          SEO
      ============================ */}
      <Helmet>
        <title>AQ Sense™ Air Quality Monitor | Aerzen Air™</title>
        <meta
          name="description"
          content="AQ Sense™ by Aerzen Air™ is a compact air quality monitor displaying real-time PM2.5, PM10 and AQI levels. Designed for Indian air pollution conditions."
        />
        <link
          rel="canonical"
          href="https://www.aerzenair.com/aq-sense"
        />
      </Helmet>

      {/* ============================
          HERO
      ============================ */}
      <div className="grid md:grid-cols-2 gap-12 items-center mb-20">
        <div>
          <span className="inline-block mb-3 px-3 py-1 text-xs font-semibold rounded-full bg-yellow-100 text-yellow-800">
            Launching Soon
          </span>

          <h1 className="text-4xl font-bold mb-4">
            AERZEN AIR™ AQ Sense
          </h1>

          <p className="text-gray-700 mb-6">
            AERZEN AIR™ AQ Sense is a compact air quality monitoring accessory
            designed to display real-time PM2.5, PM10, and AQI levels.
          </p>

          <p className="text-gray-700">
            Built specifically for Indian conditions. Plug & play.
            No app. No pairing. No complexity.
          </p>
        </div>

        <div className="rounded-2xl bg-gray-100 p-6 flex items-center justify-center">
          <img
            src="/images/aq-sense/hero.jpg"
            alt="AERZEN AIR AQ Sense air quality monitor"
            className="w-full max-w-[540px] object-contain drop-shadow-md"
          />
        </div>
      </div>

      {/* ============================
          WHAT IT SHOWS
      ============================ */}
      <div className="mb-20">
        <h2 className="text-2xl font-semibold mb-6">
          What It Shows
        </h2>

        <div className="grid md:grid-cols-2 gap-8 items-center">
          <ul className="space-y-3 text-gray-700">
            <li>• PM2.5 concentration</li>
            <li>• PM10 concentration</li>
            <li>• Overall AQI (colour-coded)</li>
            <li>• Large, easy-to-read display</li>
            <li>• USB-C powered</li>
            <li>• No app required</li>
          </ul>

          <div className="rounded-xl bg-gray-100 p-5 flex items-center justify-center">
            <img
              src="/images/aq-sense/features.jpg"
              alt="AQ Sense air quality monitoring features"
              className="w-full max-w-[480px] object-contain drop-shadow-sm"
            />
          </div>
        </div>
      </div>

      {/* ============================
          PRICING
      ============================ */}
      <div className="mb-20">
        <h2 className="text-2xl font-semibold mb-6">
          Pricing
        </h2>

        <div className="grid md:grid-cols-2 gap-6 max-w-3xl">
          <div className="border rounded-xl p-6">
            <div className="text-sm text-gray-500 mb-1">
              Standalone Price
            </div>
            <div className="text-3xl font-bold">₹3,499</div>
          </div>

          <div className="border rounded-xl p-6 bg-gray-50">
            <div className="text-sm text-gray-500 mb-1">
              With AERZEN AIR™ Purifier
            </div>
            <div className="text-3xl font-bold">₹2,599</div>
            <div className="text-xs text-gray-500 mt-2">
              Available only with purifier purchase
            </div>
          </div>
        </div>
      </div>

      {/* ============================
          SPECIFICATIONS
      ============================ */}
      <div className="mb-20">
        <h2 className="text-2xl font-semibold mb-6">
          Specifications
        </h2>

        <div className="grid md:grid-cols-2 gap-8 items-center">
          <ul className="text-gray-700 space-y-2">
            <li><strong>Dimensions:</strong> 80 × 66 × 35 mm</li>
            <li><strong>Display:</strong> AQI + PM2.5 + PM10</li>
            <li><strong>Indicator:</strong> Green / Yellow / Orange / Red</li>
            <li><strong>Power:</strong> USB-C</li>
          </ul>

          <div className="rounded-xl bg-gray-100 p-5 flex items-center justify-center">
            <img
              src="/images/aq-sense/dimensions.jpg"
              alt="AQ Sense device dimensions"
              className="w-full max-w-[460px] object-contain drop-shadow-sm"
            />
          </div>
        </div>
      </div>

      {/* ============================
          INTEREST / NOTIFY CTA
      ============================ */}
      <div className="max-w-3xl mx-auto text-center border rounded-2xl p-8 bg-gray-50">
        <h3 className="text-xl font-semibold mb-2">
          Interested in AQ Sense?
        </h3>

        <p className="text-gray-600 text-sm mb-6">
          Share your details and we’ll notify you when AQ Sense becomes
          available. No spam. No obligation.
        </p>

        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <button
            onClick={() => window.open(FORM_LINK, "_blank")}
            className="px-6 py-3 rounded-lg bg-black text-white font-medium hover:bg-gray-900"
          >
            Notify Me at Launch
          </button>

          <button
            onClick={() => window.open(FORM_LINK, "_blank")}
            className="px-6 py-3 rounded-lg border font-medium hover:bg-white"
          >
            I’m Interested — Please Contact Me
          </button>
        </div>
      </div>
    </section>
  );
}
